import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Are the casinos on Regal Play licensed and safe?',
      answer: 'Absolutely. Every casino we feature holds a valid UK Gambling Commission license. We verify licenses, test security measures, and ensure platforms use encryption to protect your data. Player safety is our top priority.'
    },
    {
      question: 'How do I claim the welcome bonuses?',
      answer: 'Each casino has its own process, but generally: create an account, verify your identity, make your first deposit, and the bonus is credited automatically. Some require bonus codes—we provide these when needed. Always check the terms for wagering requirements.'
    },
    {
      question: 'Can I play at these casinos from anywhere in the UK?',
      answer: 'Yes. All featured casinos accept UK players from England, Scotland, Wales, and Northern Ireland. You must be 18+ and located within the UK when playing. Some casinos also accept players from other countries, but we focus on UK-licensed operators.'
    },
    {
      question: 'How quickly can I withdraw my winnings?',
      answer: 'Withdrawal times vary by casino and payment method. E-wallets typically process in 24-48 hours, while bank transfers can take 3-5 business days. We highlight fast-payout casinos in our reviews. Account verification must be complete before any withdrawal.'
    },
    {
      question: 'Do you receive commission from casinos?',
      answer: 'Some links on our site are affiliate links, meaning we may earn a commission if you sign up through our links. This never influences our reviews or recommendations—we only feature casinos we genuinely believe offer value to players.'
    },
    {
      question: 'What makes Regal Play different from other review sites?',
      answer: 'We focus on real value, not just listing casinos. Our team tests platforms, verifies bonuses, and tracks player experiences. We update reviews regularly and only recommend casinos that meet our high standards for safety, fairness, and player satisfaction.'
    }
  ];

  return (
    <section id="faq" className="py-20 bg-regal-gray">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-gray-400">
              Everything you need to know about Regal Play and UK online casinos
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-regal-dark border border-gray-800 rounded-lg overflow-hidden"
              >
                <button
                  className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-regal-gray transition-colors"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-lg font-semibold text-white pr-4">
                    {faq.question}
                  </span>
                  {openIndex === index ? (
                    <ChevronUp className="text-regal-red flex-shrink-0" size={20} />
                  ) : (
                    <ChevronDown className="text-gray-400 flex-shrink-0" size={20} />
                  )}
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;

